// extracted by mini-css-extract-plugin
module.exports = {"icons":"icons-18ehP","icon":"icon-3Qy1P"};